import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransfer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.9554 5.16189C12.9581 5.71417 12.5126 6.16408 11.9603 6.1668C10.2308 6.1753 8.50721 6.83853 7.18858 8.15716C5.86994 9.4758 5.20671 11.1994 5.19821 12.9289C5.19549 13.4812 4.74558 13.9267 4.19331 13.924C3.64103 13.9212 3.19552 13.4713 3.19823 12.9191C3.20922 10.684 4.06816 8.44916 5.77436 6.74295C7.48057 5.03674 9.71544 4.17781 11.9505 4.16682C12.5027 4.16411 12.9527 4.60962 12.9554 5.16189Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.7761 4.47565C14.1646 4.86582 14.1646 5.49665 13.7761 5.88683L11.5519 8.12055C11.1622 8.51192 10.5291 8.51327 10.1377 8.12359C9.74635 7.7339 9.74499 7.10074 10.1347 6.70938L11.6563 5.18124L10.1347 3.6531C9.74499 3.26174 9.74635 2.62857 10.1377 2.23889C10.5291 1.8492 11.1622 1.85056 11.5519 2.24192L13.7761 4.47565Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.2766 17.6981C17.797 17.4243 17.6301 16.8135 17.9039 16.3339C18.7613 14.8319 19.0487 13.0076 18.5661 11.2063C18.0834 9.405 16.9223 7.96882 15.4288 7.09672C14.9519 6.81823 14.791 6.20584 15.0695 5.72891C15.348 5.25198 15.9604 5.09111 16.4373 5.3696C18.3674 6.49663 19.8734 8.35793 20.4979 10.6886C21.1224 13.0194 20.7489 15.3843 19.6409 17.3254C19.3671 17.805 18.7563 17.9719 18.2766 17.6981Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.4606 18.752C17.9284 18.8934 17.3821 18.5779 17.2385 18.0464L16.4161 15.0034C16.272 14.4702 16.5874 13.9212 17.1206 13.7771C17.6537 13.633 18.2027 13.9484 18.3468 14.4816L18.9094 16.5634L20.9936 16.0097C21.5274 15.8679 22.0751 16.1857 22.2169 16.7194C22.3587 17.2532 22.0409 17.8009 21.5071 17.9427L18.4606 18.752Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.75056 16.0476C5.22714 15.7686 5.83973 15.9287 6.11882 16.4052C6.99279 17.8977 8.43042 19.0569 10.2323 19.5373C12.0342 20.0177 13.8582 19.728 15.3591 18.8688C15.8384 18.5944 16.4494 18.7605 16.7238 19.2398C16.9982 19.7191 16.832 20.3301 16.3527 20.6045C14.413 21.7149 12.0486 22.0914 9.7171 21.4698C7.38559 20.8482 5.52242 19.3446 4.39297 17.4159C4.11388 16.9393 4.27398 16.3267 4.75056 16.0476Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.74546 15.6813C3.88844 15.1495 4.43436 14.8335 4.96669 14.9742L8.01425 15.7797C8.5482 15.9208 8.86664 16.468 8.72551 17.002C8.58438 17.5359 8.03712 17.8544 7.50318 17.7133L5.41828 17.1622L4.85828 19.2447C4.71486 19.778 4.16624 20.0941 3.6329 19.9507C3.09956 19.8073 2.78347 19.2587 2.92689 18.7253L3.74546 15.6813Z",
			fill: "currentColor"
		})
	]
});
export default SvgTransfer;
